import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Stack } from "@mui/material";

import CachedIcon from "@mui/icons-material/Cached";
import { AddCircleOutline as AddCircleOutlineIcon } from "@mui/icons-material";

import UserModal from "./component/M_User";
import AdminTable from "./component/T_Admin";

import useAuth from "../../../hooks/useAuth";
import useUser from "../../../hooks/super/useUser";
import { UserType } from "../../../utils/constants";

import { CollapseAlert } from "../../../components/pages/common/styled";
import PageHeader from "../../../components/pages/_new/super/common/PageHeader";
import PrimaryButton from "../../../components/pages/_new/super/common/PrimaryButton";
import OutlinedButton from "../../../components/pages/_new/super/common/OutlinedButton";

function SAAdmins() {
  const { isAuthenticated, adminUserType } = useAuth();
  const { getAdmins, admins, setErr, errMsg } = useUser();
  const [errOpen, setErrOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const refresh = () => {
    getAdmins();
  };

  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (isAuthenticated) {
      getAdmins();
    }
    return () => setErr(null);
  }, [isAuthenticated, getAdmins, setErr]);

  React.useEffect(() => {
    if (errMsg) setErrOpen(true);
  }, [errMsg]);

  return (
    <React.Fragment>
      <Helmet title="SA Administrators" />
      <PageHeader
        title="Administrators Management"
        description="Manage platform administrators with super-admin access"
        actions={
          <>
            <OutlinedButton
              onClick={refresh}
              startIcon={<CachedIcon style={{ width: 20, height: 20 }} />}
            >
              Refresh
            </OutlinedButton>
            <PrimaryButton
              onClick={handleOpen}
              startIcon={<AddCircleOutlineIcon style={{ width: 20, height: 20 }} />}
              disabled={null === admins || UserType.SUPER_ADMIN !== adminUserType}
            >
              Add Administrator
            </PrimaryButton>
          </>
        }
      />
      <Box sx={{ mb: 4 }}>
        <CollapseAlert errOpen={errOpen} setErrOpen={setErrOpen} setErr={setErr} errMsg={errMsg} />
      </Box>
      <Stack spacing={4}>
        <AdminTable />
      </Stack>
      <UserModal open={open} handleClose={handleClose} adminFlag={true} />
    </React.Fragment>
  );
}
export default SAAdmins;
